import { FC } from 'react';

import Button from 'components/_core/Button';

import { usePhysicalCardOrderFlowContext } from '../../../../hooks/usePhysicalCardOrderFlowContext';
import locales from './locales';

const ToggleShowPasscode: FC = () => {
  const { setSharedState, sharedState } = usePhysicalCardOrderFlowContext();
  const { isPasscodeShown } = sharedState;

  const onToggle = () => {
    setSharedState({ ...sharedState, isPasscodeShown: !isPasscodeShown });
  };

  return (
    <Button
      icon={isPasscodeShown ? 'eye-close' : 'eye-open'}
      iconPosition="left"
      onClick={onToggle}
      variant="secondary"
    >
      {isPasscodeShown ? locales.hidePasscode : locales.showPasscode}
    </Button>
  );
};

export default ToggleShowPasscode;
